export default __webpack_public_path__ + "static/media/selected.3eec0559.svg";